import * as Scrivito from 'scrivito';

Scrivito.provideObjClass('Pdf', {
  attributes: {
    blob: 'binary',
    alt: 'string',
  },
});
